export default __webpack_public_path__ + "static/banner-571c18258f663549c1c1b5c87bea77c7.svg";